// extracted by mini-css-extract-plugin
export default {"relativeContainer":"_2cDMG","container":"bVAkx"};